import {
  FacebookServices as Facebook,
  GoogleServices as Google,
} from '@clearkit/icons';

import Contacts from '~/components/audiences/Tile/Contacts.svg';
import Prospects from '~/components/audiences/Tile/Prospects.svg';
import Visitors from '~/components/audiences/Tile/Visitors.svg';
import Tooltip from '~/components/RedesignedTooltip';
import ConversionsDisabled from '~/images/planGates/increase_conversion_rates_disabled.svg';
import Conversions from '~/images/planGates/increase_conversion_rates.svg';
import { segmentTypes } from '~/lib/segments';

import {
  useHasAcquisitionsAccess,
  useHasConversionsAccess,
} from '../../../../hooks/account/usePlatformAccess';
import AddPlanPanel from './AddPlanPanel';
import styles from './styles';

function AddAcquisitionsPlan({ classes, segment }) {
  const hasConversionsPlan = useHasConversionsAccess();
  const hasAcquisitionsPlan = useHasAcquisitionsAccess();

  if (hasAcquisitionsPlan) {
    return null;
  }

  let destinations = [
    {
      name: 'Contact audiences',
      description: 'Advertise to people in your database',
      icon: <Contacts className={classes.logo} />,
    },
  ];

  switch (segment.type) {
    case segmentTypes.company:
      destinations = destinations.concat([
        {
          name: 'Prospect audiences',
          description: 'Find ideal customers & advertise to them',
          icon: <Prospects className={classes.logo} />,
        },
        {
          name: 'Site Visitor audiences',
          description: 'Advertise based on your website traffic',
          icon: <Visitors className={classes.logo} />,
        },
      ]);
      break;

    case segmentTypes.person:
      destinations = destinations.concat([
        {
          name: 'Offline conversion events',
          description: 'Optimize your ad spend',
          icon: hasConversionsPlan ? (
            <Tooltip
              placement="top"
              title="Available through your Convert Intent plan"
            >
              <ConversionsDisabled className={classes.logo} />
            </Tooltip>
          ) : (
            <Conversions className={classes.logo} />
          ),
        },
      ]);
      break;
  }

  return (
    <AddPlanPanel
      description="Build and sync precise audiences using your CRM data, website data, and 100+ firmographic, technographic, and employee attributes."
      destinations={destinations}
      footerDescription="Sync with Facebook Custom Audiences, Facebook Retargeting, and Google Remarketing"
      footerIcons={[Facebook, Google]}
      title="Generate Demand"
    />
  );
}
export default withStyles(styles)(AddAcquisitionsPlan);
